export const Footer = (): JSX.Element => (
  <footer>
    <div>
      <img src="/static/120-logo-1c-black-resize-1.png" alt="120Water Logo" />
    </div>
    <section className="information">
      <div className="content">
        <span>This Public Transparency Dashboard is powered by 120Water.</span>
      </div>
      <div className="content">
        <span>
          <a
            target="_blank"
            href="https://120wateraudit.com/public-transparency/"
          >
            Visit our website
          </a>{' '}
          to learn about how to keep our drinking water safe.
        </span>
      </div>
    </section>
    <div className="subContent">
      <span>
        &copy; {new Date().getFullYear()} 120Water &#183;{' '}
        <a target="_blank" href="https://120wateraudit.com/terms-of-use/">
          Terms and Conditions
        </a>{' '}
        &#183;{' '}
        <a target="_blank" href="https://120wateraudit.com/privacy-policy/">
          Privacy Policy
        </a>
      </span>
    </div>
  </footer>
)
